module.exports = __webpack_public_path__ + "static/hexomatic-logo-cec88b5dd885dac354736350f6cb7ed9.svg";